export default __webpack_public_path__ + "static/media/logoFooter.8590a4dd.png";